<template>
  <v-container id="data-tables" tag="section">
    <base-material-card
      color="grey darken-3"
      icon="mdi-account-group"
      inline
      class="px-5 py-3"
    >
      <template v-slot:after-heading>
        <div class="display-2 font-weight-light">
          {{ $t("Courses") }}
        </div>
      </template>
      <div class="text-right">
        <v-btn
          class="ma-1"
          color="primary"
          @click="$router.push({ name: 'course.create' })"
        >
          {{ $t("create") }}
        </v-btn>
      </div>
      <v-text-field
        v-model="search"
        append-icon="mdi-magnify"
        class="ml-auto"
        :label="$t('search')"
        hide-details
        single-line
        style="max-width: 250px;"
      />
      <advanced-data-table
        :headers="headers"
        :items="items"
        :options.sync="options"
        :server-items-length="total"
        :loading="loading"
        :multi-sort="true"
        class="elevation-1"
        :filterCols="filterCols"
        :filters="filters"
        v-on:filter="
          filters = $event;
          getData();
        "
      >
        <template v-slot:item.name="{ item }">
          <a
            @click="$router.push({ path: '/be/course/' + item.id + '/show' })"
            >{{ item.name }}</a
          >
        </template>
        <template v-slot:item.from="{ item }">
          {{ item.from | formatYear }}
        </template>
        <template v-slot:item.action="{ item }">
          <v-icon small class="mr-2" @click="showItem(item)">
            mdi-eye
          </v-icon>
          <v-icon small class="mr-2" @click="editItem(item)">
            mdi-pencil
          </v-icon>
          <v-icon small class="mr-2" @click="deleteItem(item)">
            mdi-delete
          </v-icon>
          <v-icon small class="mr-2" @click="copy(item)">
            mdi-content-duplicate
          </v-icon>
        </template>
        <template v-slot:item.active="{ item }">
          <v-icon v-if="item.active" small @click="switchActive(item)">
            mdi-check
          </v-icon>
          <v-icon small v-else @click="switchActive(item)">
            mdi-lock
          </v-icon>
        </template>
      </advanced-data-table>
      <v-divider class="mt-3" />
    </base-material-card>
  </v-container>
</template>

<script>
import {
  fetchItems,
  deleteItem,
  changeActiveItem,
  copyItem
} from "../shared/services";

export default {
  name: "app-course-list",
  data() {
    return {
      headers: [
        {
          text: "Name",
          align: "left",
          value: "name"
        },
        {
          text: "Status",
          align: "left",
          value: "active"
        },
        {
          text: "Jahr",
          align: "left",
          value: "from"
        },
        { text: "", value: "action", sortable: false }
      ],
      filters: [],
      loading: true,
      options: {},
      total: 0,
      search: "",
      items: []
    };
  },

  computed: {
    filterCols() {
      return [
        {
          title: this.$t("year"),
          name: "from",
          type: "select",
          props: {
            itemText: "name",
            itemValue: "id"
          },
          items: [
            {
              id: "2022",
              name: "2022"
            },
            {
              id: "2023",
              name: "2023"
            },
            {
              id: "2024",
              name: "2024"
            },         
            {
              id: "2025",
              name: "2025"
            }
          ]
        },
        {
          title: this.$t("active"),
          name: "active",
          type: "select",
          props: {
            itemText: "name",
            itemValue: "id"
          },
          items: [
            {
              id: 1,
              name: this.$t("yes")
            },
            {
              id: 0,
              name: this.$t("no")
            }
          ]
        }
      ];
    }
  },
  created() {
    this.filters = ["active|1"];
    this.getData();
  },

  methods: {
    async getData() {
      this.loading = true;
      let response = await fetchItems({
        ...this.options,
        search: this.search,
        filters: this.filters
      });
      this.items = response.data;
      this.total = response.meta.total;
      this.loading = false;
    },
    async deleteItem(item) {
      if (
        await this.$root.$confirm(
          this.$t("Delete"),
          this.$t("Are you sure to delete this Course?")
        )
      ) {
        let resp = await deleteItem(item.id);
        if (resp.success) {
          this.$notification(resp.message, { type: "success" });
        } else {
          this.$notification(resp.message, { type: "error" });
        }
        this.getData();
      }
    },
    async copy(item) {
      if (
        await this.$root.$confirm(
          this.$t("Delete"),
          this.$t("Are you sure to copy this Course?")
        )
      ) {
        let resp = await copyItem(item.id);
        if (resp.success) {
          this.$notification(resp.message, { type: "success" });
        } else {
          this.$notification(resp.message, { type: "error" });
        }
        this.getData();
      }
    },
    async switchActive(item) {
      if (
        await this.$root.$confirm(
          this.$t("Switch State"),
          this.$t("Are you sure to set the course to ") +
            (item.active ? this.$t("inactive") : this.$t("active")) +
            "?"
        )
      ) {
        let resp = await changeActiveItem(item.id);
        if (resp.success) {
          this.$notification(resp.message, { type: "success" });
        } else {
          this.$notification(resp.message, { type: "error" });
        }
        this.getData();
      }
    },
    editItem(item) {
      let url = item.id;
      this.$router.push({ name: "course.edit", params: { id: url } });
    },
    showItem(item) {
      let url = item.id;
      this.$router.push({ name: "course.show", params: { id: url } });
    }
  },
  watch: {
    options: {
      handler() {
        this.getData();
      },
      deep: true
    },
    search: {
      handler() {
        this.getData();
      }
    }
  }
};
</script>

<style lang="scss" scoped></style>
